import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  initialize() {
    this.element.colSpan = this.element
      .closest('table')
      .querySelectorAll('th').length;
  }
}
